import type { Date__Input } from '~/graphql/types';
import type { ValidationError } from '../../../../state/validationState';

const text = {
  selectDate: 'Selecteer een datum voor uitstellen',
  invalidDate: 'Ongeldige datum geselecteerd',
  pastDate: 'Datum kan niet in het verleden liggen',
  futureDate: 'Datum kan maximaal 3 maanden in de toekomst liggen',
  addNote: 'Voeg een opmerking toe voor het uitstellen',
};

// Utility function to calculate today's date at midnight
const getTodayMidnight = (): Date => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

// Utility function to calculate a future date
const addMonthsToDate = (date: Date, months: number): Date => {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + months);
  return newDate;
};

const validateSnoozeData = (
  snoozeUntil: Date__Input | null,
  snoozeNote: string,
): Array<ValidationError> => {
  const errors: Array<ValidationError> = [];

  if (!snoozeUntil?.Day?.d && !snoozeUntil?.DayTime?.d) {
    errors.push({
      field: 'snoozeDate',
      message: text.selectDate,
    });
  } else {
    const snoozeDate = new Date(
      snoozeUntil.Day?.d || snoozeUntil.DayTime?.d || '',
    );

    // Ensure the snooze date is valid
    if (isNaN(snoozeDate.getTime())) {
      errors.push({
        field: 'snoozeDate',
        message: text.invalidDate,
      });
    } else {
      const today = getTodayMidnight();
      const threeMonthsFromNow = addMonthsToDate(today, 3);

      if (snoozeDate < today) {
        errors.push({
          field: 'snoozeDate',
          message: text.pastDate,
        });
      }

      if (snoozeDate > threeMonthsFromNow) {
        errors.push({
          field: 'snoozeDate',
          message: text.futureDate,
        });
      }
    }
  }

  if (!snoozeNote.trim()) {
    errors.push({
      field: 'snoozeNote',
      message: text.addNote,
    });
  }

  return errors;
};

export default validateSnoozeData;
